export class ProjectPageDescription {
    private readonly container: HTMLElement | null;
    private readonly _hiddenStyleClass = 'hidden';
    private readonly _showFullDescriptionSelector = '.js-view-more-button';
    private readonly _containerSelector = '.js-description-container';
    private readonly _excerptTargetAttributeName = 'data-excerpt-target';
    private readonly _fullTargetAttributeName = 'data-full-target';

    constructor() {
        this.container = document.querySelector(this._containerSelector)
    }

    init() {
        if (!this.container) {
            return;
        }
        this.container.querySelectorAll(`${this._showFullDescriptionSelector}`).forEach((showFullDescriptionElement) => {
            if (showFullDescriptionElement instanceof HTMLElement && showFullDescriptionElement.dataset.totalUnits !== '0') {
                this.registerToggleDescriptionOnClickEvent(showFullDescriptionElement);
            }
        })
    }

    private registerToggleDescriptionOnClickEvent(showFullDescriptionElement: Element) {
        showFullDescriptionElement.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            const showFullDescriptionElement = event.currentTarget as HTMLElement;
            if (showFullDescriptionElement) {
                this.toggleDescription(showFullDescriptionElement);
            }
        });
    }

    private toggleDescription(showFullDescriptionElement: HTMLElement) {
        showFullDescriptionElement.classList.add(this._hiddenStyleClass);
        this.hideExcerpt(showFullDescriptionElement);
        this.showFullDescription(showFullDescriptionElement);
    }

    private hideExcerpt(showFullDescriptionElement: HTMLElement) {
        let excerptDescriptionSelector = showFullDescriptionElement.getAttribute(this._excerptTargetAttributeName)!!;
        // @ts-ignore
        this.container.querySelectorAll(excerptDescriptionSelector).forEach((excerptElement) => {
            excerptElement.classList.add(this._hiddenStyleClass);
        });
    }

    private showFullDescription(showFullDescriptionElement: HTMLElement) {
       let fullDescriptionSelector = showFullDescriptionElement.getAttribute(this._fullTargetAttributeName)!!;
        // @ts-ignore
        this.container.querySelectorAll(fullDescriptionSelector).forEach((excerptElement) => {
            excerptElement.classList.remove(this._hiddenStyleClass);
        });
    }
}

window.addEventListener("load", () => {
    new ProjectPageDescription().init();
});
